/**
 * Split free-form release notes into one line per sentence so the UI can
 * render them as a bullet list. Existing line breaks are respected; inside
 * a line we split on `.`, `!`, `?` followed by whitespace and an uppercase
 * letter / opening quote — this keeps version numbers ("1.0.17"), "e.g." and
 * mid-sentence lowercase continuations intact.
 *
 * @param {string} text
 * @returns {string[]}
 */
export function changelogLines(text) {
  if (!text || typeof text !== "string") return []
  return text
    .split(/\r?\n+/)
    .flatMap((line) => line.split(/(?<=[.!?])\s+(?=["“(]?[A-Z0-9])/))
    .map((s) => s.trim().replace(/^[-•–*]\s*/, ""))
    .filter(Boolean)
}
